module.exports = __webpack_public_path__ + "img/customer-a-094.920faadb.png";